import React from 'react';
import palette from '@mlc/mlc-palette';
import { LDToggle } from '@mlconline/react-launch-darkly';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { Paragraph } from '@mlc/web-ui-toolkit';
import { isCsr } from '../../../../common/utils';
import { useAdviserDetails } from '../../../../hooks/AppStateHook';
import links from './data.applyOnlineLinks.json';
import elements from './ApplyOnline.elements';
import * as Styled from './styled';

interface Props {}

const ApplyOnline: React.FunctionComponent<Props> = (props: Props) => (
	<Styled.Card>
		<Styled.WhiteLabel variant="button">Apply online for:</Styled.WhiteLabel>
		<Styled.Ul data-id={elements.applyLinks}>
			{links.map(link => (
				<LDToggle
					key={'toggle-' + link.name}
					ldFlag={link.toggleFlag}
					defaultComponent={
						<ListItemLink
							key={link.name as string}
							{...{ ...link, location: link.location }}
						/>
					}
				>
					<ListItemLink
						key={link.name as string}
						{...{ ...link, location: link.oldLocation }}
					/>
				</LDToggle>
			))}
		</Styled.Ul>
	</Styled.Card>
);

const ListItemLink = (link: Link) => {
	const { roles } = useAdviserDetails();
	const isDisabled = link.disableForCsr && isCsr(roles);
	return (
		<Styled.Li>
			<Styled.Anchor
				href={link.location}
				target="_blank"
				analyticsId={link.analyticsId}
				disabled={isDisabled}
			>
				<Paragraph color={palette.mlcWhite} marginBottom={0}>
					{link.name}
				</Paragraph>
			</Styled.Anchor>
			<FontAwesomeIcon
				icon={faExternalLink}
				size="xs"
				color={isDisabled ? palette.mlcWallaby : palette.mlcWhite}
			/>
		</Styled.Li>
	);
};

export default ApplyOnline;

export interface Link {
	name: string;
	location: string;
	analyticsId: string;
	disableForCsr: boolean;
}
